export const SAFE_PATH = /^\/(?![/\\])[A-Za-z0-9._~\-/?&=#%+:@,;()*!'$]*$/
